import { render } from "./FlowView.vue?vue&type=template&id=c21c1e08&scoped=true"
import script from "./FlowView.vue?vue&type=script&lang=js"
export * from "./FlowView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c21c1e08"

export default script